import { render, staticRenderFns } from "./SimpleGeneralForm.vue?vue&type=template&id=36d05d00"
import script from "./SimpleGeneralForm.vue?vue&type=script&lang=ts"
export * from "./SimpleGeneralForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports